import utils from '@/utils/utils.js';
import rules from '@/utils/validateRules.js';

const rule = {
  integer: '|integer',
  decimal: '|double',
  date: '|date',
};

export default ({ formData, inputGroup, initialSchema }) => {
  const groupFormData = inputGroup
    ? formData.filter((data) => data.input_group === inputGroup)
    : formData;

  const validationSchema = Object.values(formData).reduce((prev, current) => {
    if (inputGroup && current.input_group !== inputGroup) return prev;

    const dataTypeRule = rule[current.data_type] || '';
    const validateRule = current.input_validation_rule + dataTypeRule;
    const validate = (value) => rules.validate(value, validateRule);

    return { ...prev, ['itemId' + current.id]: validate };
  }, initialSchema || {});

  const detectHiddenItems = (inputValues) => {
    const items = Object.entries(inputValues).reduce((prev, current) => {
      const [key, values] = current;
      if (key.indexOf('itemId') === -1) return prev;

      const id = key.replace('itemId', '');
      return [...prev, { id, values }];
    }, []);

    return utils.checkHiddenItems(formData, items);
  };

  return {
    groupFormData,
    validationSchema,
    detectHiddenItems,
  };
};
